module.exports = __webpack_public_path__ + "static/media/XBOX1.986adaeb.png";